import { scrollBehavior } from './scroll_behavior';

const SCROLL_OFFSET = -150;

export const setDisclosureOpen = (button, open) => {
  const panel = document.getElementById(button.getAttribute('aria-controls'));

  if (!panel) {
    return;
  }

  // Collapsing a panel that holds an open modal would leave the whole document
  // inert with nothing on screen, up to the next reload.
  if (!open && panel.querySelector('dialog[open]')) {
    return;
  }

  button.setAttribute('aria-expanded', String(open));
  panel.hidden = !open;
};

// Nothing inside a collapsed panel can be displayed or focused, so callers about to
// reveal a target expand the panels holding it first.
export const expandAncestorDisclosures = element => {
  let ancestor = element.parentElement;

  while (ancestor) {
    if (ancestor.hasAttribute('hidden') && ancestor.id) {
      const button = document.querySelector(
        `[data-disclosure][aria-controls="${CSS.escape(ancestor.id)}"]`,
      );

      if (button) {
        setDisclosureOpen(button, true);
      }
    }

    ancestor = ancestor.parentElement;
  }
};

const closeSiblings = button => {
  const group = button.dataset.disclosureGroup;

  if (!group) {
    return;
  }

  document
    .querySelectorAll(
      `[data-disclosure-group="${CSS.escape(group)}"][aria-expanded="true"]`,
    )
    .forEach(other => {
      if (other !== button) {
        setDisclosureOpen(other, false);
      }
    });
};

const scrollToButton = button => {
  const top =
    button.getBoundingClientRect().top + window.scrollY + SCROLL_OFFSET;

  window.scrollTo({ top, behavior: scrollBehavior() });
};

if (window.disclosureInitialized === undefined) {
  window.disclosureInitialized = true;

  document.addEventListener('click', event => {
    const button = event.target.closest('[data-disclosure]');

    if (!button) {
      return;
    }

    const open = button.getAttribute('aria-expanded') !== 'true';

    if (open) {
      closeSiblings(button);
    }

    setDisclosureOpen(button, open);

    if (open && 'disclosureScroll' in button.dataset) {
      scrollToButton(button);
    }
  });

  const desktop = window.matchMedia('(min-width: 640px)');

  const syncResponsive = () => {
    document
      .querySelectorAll('[data-disclosure-responsive]')
      .forEach(button => setDisclosureOpen(button, desktop.matches));
  };

  desktop.addEventListener('change', syncResponsive);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncResponsive);
  } else {
    syncResponsive();
  }
}
